import Phaser from 'phaser';

const BG_OUTER = 0x4c0519;
const BG_INNER = 0x7f1d1d;
const EYELID = 0xfbbf24;
const EYELID_SHADOW = 0x92400e;
const PUPIL_GLOW = 0x86efac;
const PUPIL = 0x16a34a;
const PUPIL_DARK = 0x14532d;
const SPARKLE = 0xffffff;
const STROKE = 0x0a0f1f;

export function drawEye(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const eyeW = r * 1.35;
  const eyeH = r * 0.78;

  g.fillStyle(EYELID, 1);
  g.lineStyle(Math.max(1, Math.floor(stroke * 0.8)), STROKE, 1);
  g.beginPath();
  g.moveTo(-eyeW / 2, 0);
  g.arc(0, 0, eyeW / 2, Math.PI, 0, false);
  g.lineTo(eyeW / 2, 0);
  g.arc(0, 0, eyeW / 2, 0, Math.PI, false);
  g.closePath();
  g.fillPath();
  g.strokePath();

  g.fillStyle(EYELID_SHADOW, 0.5);
  g.beginPath();
  g.moveTo(-eyeW / 2, 0);
  g.arc(0, 0, eyeW / 2, Math.PI, 0, false);
  g.lineTo(-eyeW / 2, 0);
  g.closePath();
  g.fillPath();

  const irisR = eyeH * 0.55;
  g.fillStyle(PUPIL_GLOW, 1);
  g.fillCircle(0, 0, irisR * 1.05);
  g.fillStyle(PUPIL, 1);
  g.fillCircle(0, 0, irisR * 0.9);
  g.fillStyle(PUPIL_DARK, 1);
  g.fillCircle(0, 0, irisR * 0.42);

  g.fillStyle(SPARKLE, 1);
  g.fillCircle(-irisR * 0.3, -irisR * 0.3, irisR * 0.15);

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.7)), STROKE, 1);
  g.strokeCircle(0, 0, irisR * 0.9);
}
